import React, { useEffect } from "react";
import { useAuth } from "./items/AuthProvider";
import request from "../services/Request";
import Swal from "sweetalert2";
import HorizontalCard from "./Cards/HorizontalCard";

const GiftCard = ({ amount, index, expiryDate }) => {
  return (
    <div
      className="relative bg-gradient-to-br from-blue-500 to-purple-600 text-white p-3 rounded-xl shadow-lg w-56 h-30 transform transition-transform hover:scale-105 mb-4"
      key={index}
    >
      <div className="text-sm opacity-80 mb-1">Your Store Discount Card</div>
      <div className="flex justify-between items-center mb-4">
        <div className="text-2xl font-bold">${amount.toFixed(2)}</div>
      </div>

      <div className="absolute bottom-4 left-4 right-4">
        <div className="flex justify-between mt-2 text-xs opacity-70">
          <span>Expires</span>
          <span>{expiryDate ? expiryDate : "N/A"}</span>
        </div>
      </div>
    </div>
  );
};

const GiftCardPage = () => {
  const { user, setRefresh, refresh, gitf } = useAuth();

  const [value, setValue] = React.useState(0);

  useEffect(() => {
    console.log("gitf", gitf);
  }, [gitf]);

  const redeemGiftCard = () => {
    if (user?._id) {
      request({
        method: "post",
        url: "/clientPromo/create",
        data: {
          _id: user._id,
          points: value * 100,
          amount: value,
        },
      })
        .then((res) => {
          Swal.fire({
            title: "Success!",
            text: `You have redeemed ${value} points`,
            icon: "success",
            confirmButtonText: "OK",
          });
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: err.response?.data?.error?.message || "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
          });
        })
        .finally(() => {
          setRefresh(!refresh);
        });
    } else {
      console.log("Redeem gift card");
    }
  };

  return (
    <div className="page-container">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">{`Welcome, ${user?.username}!`}</h2>
      </div>

      <div className="flex items-center space-x-2">
        <button
          className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
          onClick={() => {
            // Decrease value, but not below 0
            const newValue = Math.max(0, (value || 0) - 1);
            setValue(newValue);
          }}
        >
          -
        </button>

        <input
          type="number"
          value={value || 0}
          readOnly
          className="w-20 text-center border rounded py-1"
        />

        <button
          className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
          onClick={() => {
            // Increase value, but not above max points/100
            const maxValue = Math.floor(user?.points / 100);
            const newValue = Math.min(maxValue, (value || 0) + 1);
            setValue(newValue);
          }}
        >
          +
        </button>
      </div>

      <div className="text-sm text-gray-600 mt-1">
        {`Max redeemable: $${Math.floor(user?.points / 100)}`}
      </div>

      {user?.points > 1000 && (
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
          onClick={redeemGiftCard}
        >
          Redeem Card
        </button>
      )}

      <h1 className="text-xl font-bold mt-2">{`My Discount Cards`}</h1>
      {gitf?.map((card, index) => (
        <GiftCard amount={card.amount} key={index} />
      ))}
    </div>
  );
};

export default GiftCardPage;
